import { generateInsights } from '../utils';

export function renderInsightsView(container: HTMLElement): void {
  const wrapper = document.createElement('div');
  wrapper.className = 'view-container';
  container.appendChild(wrapper);

  const insights = generateInsights();

  wrapper.innerHTML = `
    <div class="view-header">
      <h2>Key Insights</h2>
      <p>Automatically generated observations about the current state of global conflict — anomalies, extremes, and patterns worth noting.</p>
    </div>

    <div class="insights-grid">
      ${insights.map(insight => `
        <div class="insight-card ${insight.severity}">
          <h4>${insight.title}</h4>
          <p>${insight.description}</p>
        </div>
      `).join('')}
    </div>
  `;
}
